export const canJoinTelevisit = (scheduledTime?: string): boolean => {
    if (!scheduledTime) {
        return true;
    }

    const now = new Date();
    const today = now.toISOString().split('T')[0];
    const scheduledDateTime = new Date(`${today}T${scheduledTime}`);
    const diffMinutes = (scheduledDateTime.getTime() - now.getTime()) / 60000;

    return diffMinutes <= 15;
};
